<template>
	<div class="PdfViewer">
		<div id="imgDiv" v-show="false"></div>
		<vue-book-effects v-if="bookShow" class="viewerContent" ref="vueBookViewer" :startPage='startPage' :singlePage ='singlePage' :pages="pages"></vue-book-effects>
		<!-- <div class="viewerContent">
			<div class="viewer viewer1">
				<pdf class="frame" ref="pdf1" :src="pdfUrl1"></pdf>
			</div>
			<div class="viewer">
				<pdf class="frame" ref="pdf2" :src="pdfUrl2"></pdf>
			</div>
		</div>
		<div class="ctrlBtns">
			<i class="el-icon-caret-left ctrl-btn"></i>
			<el-input class="page-input" v-model="currentPage" size="mini"></el-input>
			<i class="el-icon-caret-right ctrl-btn"></i>
		</div> -->
		<div class="bg-left"></div>
		<div class="bg-left2"></div>
		<div class="bg-right"></div>
		<div class="btn-to-home" @click="jumpTo('home')">返回首页</div>
		<div class="btn-page-change btn-start" @click="flipTo(1)">
			封<br>面
		</div>
		<div class="btn-page-change btn-end" @click="flipTo(pdfUrlList.length-1)">
			封<br>底
		</div>
		<div class="btn-page-change btn-prev" @click="flipLeft">
			上<br>页
		</div>
		<div class="btn-page-change btn-next" @click="flipRight">
			下<br>页
		</div>
		<!-- <img :src="require('@/assets/images/bookview/arrow-left.png')" class="arrow-left" alt="" @click="flipLeft">
		<img :src="require('@/assets/images/bookview/arrow-right.png')" class="arrow-right" alt="" @click="flipRight"> -->
	</div>
</template>

<script>
// import pdf from 'vue-pdf'

import { getQueryString } from '@/utils'

import VueBookEffects from 'vue-book-effects'

import Config from '@/config'

// import Compressor from 'compressorjs'

export default {
	name: 'appCommonPdf',
	props: {
		pdfUrl: {
		type: String,
			default: ''
		}
	},
	components: {
		// pdf
		VueBookEffects
	},
	data () {
		return {
			// pdf: require('./A00001_00.pdf'),
			// myPdf: require('https://booktest2022.oss-cn-hangzhou.aliyuncs.com/book/pdf/100010020220000003/A00001_00.pdf'),
			pdfUrl1: '',
			pdfUrl2: '',
			pdfUrlList: [],
			currentPage: 1,
			pages: [
				// 'pdf/images/1.png',
				// 'pdf/images/2.png',
				// 'pdf/images/3.png',
				// 'pdf/images/4.png',
				// 'pdf/images/5.png',
				// 'pdf/images/6.png',
				// '1.png'
				// 'http://47.95.223.196:8090/book/pdf/100010020220000001/T00162_00.pdf'
			],
			bookShow: false,
			startPage: 1,
			singlePage: false
		}
	},
	mounted () {
		// console.log(this.myPdf);
		this.getPdfList();
		console.log($('#imgDiv'));
	},
	methods: {
		getPdfList () {
			let bookId = getQueryString('bookId');
			let bookType = getQueryString('bookType');
			let startPageName = getQueryString('startPage');
			var axios = require('axios');

			var config = {
				method: 'get',
				url: Config.ApiRoot + '/oss/getPictureLst',
				params: {
					bookId,
					bookType
				},
				headers: { }
			};

			let that = this;

			axios(config).then(function (response) {
				// console.log(JSON.stringify(response.data.code));
				let pdfList = [];
				that.pdfUrlList = [];
				if (response.data.code === 200) {
					pdfList = response.data.data;
				}
				if (pdfList.length === 0) {
                    that.$message({
                        message: '没有书籍数据',
                        type: 'warning'
                    });
					return;
				}
				while (pdfList[0].indexOf('.pdf') === -1) {
					pdfList.splice(0, 1);
				}
				for (let item of pdfList) {
					item = item.replace('https://bookviewstorage.oss-cn-beijing-internal.aliyuncs.com/book', 'http://47.95.223.196:8090/book');
					that.pdfUrlList.push(item);
				}
				if (bookId.substr(4, 3) === '130') {
					that.singlePage = true;
					that.pdfUrlList.shift();
				}
				that.bookShow = true;
			    console.log(that.pdfUrlList);
				// that.setCurrentPdf(0);
				let pageNum = that.pdfUrlList.findIndex(value => value.indexOf(startPageName) !== -1)
				if (pageNum >= 0) {
					 console.log('当前页：' + pageNum);
					that.addPage(pageNum);
				} else {
					 console.log('当前页：' + pageNum);
					that.addPage(0);
				}

				// that.transPdfToImage(that.pdfUrlList[0]);
			}).catch(function (error) {
				console.log(error);
			});
		},
		setCurrentPdf (startPage) {
			this.currentPage = startPage + 1;
			this.pdfUrl1 = '';
			this.pdfUrl2 = '';
			if (startPage < this.pdfUrlList.length) {
				this.pdfUrl1 = this.pdfUrlList[startPage];
			}
			if (startPage + 1 < this.pdfUrlList.length) {
				this.pdfUrl2 = this.pdfUrlList[startPage + 1];
			}
		},
		addPage (page) {
			if (page >= this.pdfUrlList.length - 1) {
			// if (page >= 60) {
				// console.log(this.pages);
				this.bookShow = true;
				return;
			}
			this.currentPage = page;
			this.transPdfToImage(this.pdfUrlList[page]);
		},
		transPdfToImage (pdfUrl) {
			let that = this;
			$('#imgDiv').empty();

			function dataURLtoBlob (dataurl) {
				var arr = dataurl.split(',');
					var mime = arr[0].match(/:(.*?);/)[1];
					var bstr = atob(arr[1]);
					var n = bstr.length;
					var u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			}
			// function fileToDataURL (file) {
			// 	let reader = new FileReader()
			// 	reader.readAsDataURL(file)
			// 	// reader 读取文件成功的回调
			// 	reader.onload = function (e) {
			// 	return reader.result
			// 	}
			// }
			// function blobToFile (value, filename = 'file') {
			// return new window.File([value], filename, { type: value.type });
			// }

			function output () {
				var height = 0; var context; var mainCanvas; var b = 2; // b：整图缩放倍数
				var count = $('canvas').length;
				$('canvas').each(function (index, ele) {
					var canvas = document.getElementById('pdfCanvas');
					if (canvas) {
						if (index === 0) {
							mainCanvas = document.createElement('canvas');
							context = mainCanvas.getContext('2d');
							mainCanvas.width = canvas.width / b;
							mainCanvas.height = canvas.height / b * count;
							context.drawImage(canvas, 0, 0, canvas.width / b, canvas.height / b);
						} else {
							context.drawImage(canvas, 0, height, canvas.width / b, canvas.height / b);
						}
						height += canvas.height / b;
					}
				})
				if (mainCanvas) {
					// let img = dataURLtoBlob(mainCanvas.toDataURL('image/png', 1.0));
					let img = mainCanvas.toDataURL('image/png', 0.1);
					console.log('压缩前', dataURLtoBlob(img));
					// eslint-disable-next-line no-new
					// new Compressor(dataURLtoBlob(img), {
					// 	quality: 0,
					// 	success (result) {
					// 		console.log(result) // 处理后的文件流BLOB
					// 		let reader = new FileReader()
					// 		reader.readAsDataURL(result)
					// 		// reader 读取文件成功的回调
					// 		reader.onload = function (e) {
					// 			console.log('压缩后', reader.result);
					// 			that.pages.push(reader.result);
					// 			that.addPage(that.currentPage + 1);
					// 			$('#imgDiv').empty();
					// 			return reader.result
					// 		}
					// 	},
					// 	error (err) {
					// 	// 错误处理
					// 		console.log(err.message)
					// 	}
					// })
					that.pages.push(window.URL.createObjectURL(dataURLtoBlob(img)));
					that.addPage(that.currentPage + 1);
					$('#imgDiv').empty();
					// that.bookShow = true;
				}
			}
			function openPage (pdfFile, pageNumber, context) {
				var scale = 2;
				pdfFile.getPage(pageNumber).then(page => {
					let viewport = page.getViewport(scale); // reference canvas via context
					var canvas = context.canvas;
					canvas.width = viewport.width;
					canvas.height = viewport.height;
					// 记录当前canvas的width，height
					window.wi = canvas.width;
					window.he = canvas.height;
					canvas.style.width = '100%';
					canvas.style.height = '100%';
					var renderContext = {
						canvasContext: context,
						viewport: viewport
					};
					page.render(renderContext).then(e => {
						output();
					});
				});
			};

			PDFJS.getDocument(pdfUrl).then(pdf => {
				// console.log(pdf)
				$('#imgDiv').css('border', '0'); // 清除文本、边框
				if (pdf) {
					window.pageNum = pdf.numPages;
					// $('#pagesText').text(pageNum);
					var canvas = document.createElement('canvas');
					canvas.id = 'pdfCanvas';
					$('#imgDiv').append(canvas);
					var context = canvas.getContext('2d');
					openPage(pdf, 1, context);
				}
			});
		},
		flipTo (page) {
			this.$refs.vueBookViewer.goToPage(page);
			// this.$refs.vueBookViewer.flipStart();
		},
		flipLeft () {
			this.$refs.vueBookViewer.flipLeft();
		},
		flipRight () {
			this.$refs.vueBookViewer.flipRight();
		},
		jumpTo (page) {
			let routeUrl = this.$router.resolve({
                name: page
            })
            window.open(routeUrl.href, '_blank')
		}
	}
}
</script>

<style lang='less' scoped>
@import "~@/styles/variables.less";

.PdfViewer {
	width: 100%;
	height: 100%;
	background: #DFE1E7;
	position: relative;
	overflow: hidden;

	#imgDiv {
		position: absolute;
		z-index: 0;
	}

	.bg-left {
		background: url('~@/assets/images/bookview/bg-lfet.png') no-repeat;
		width: 274px;
		position: absolute;
		height: 200px;
		top: 0;
		left: 0;
	}

	.bg-left2 {
		background: url('~@/assets/images/bookview/bg-leftdown.png') no-repeat;
		width: 457px;
		height: 479px;
		position: absolute;
		left: 0;
		top: 511px;
	}

	.bg-right {
		background: url('~@/assets/images/bookview/bg-right.png') no-repeat;
		width: 275px;
		height: 360px;
		position: absolute;
		right: 0;
		top: 20%;
	}

	.btn-to-home {
		position: absolute;
		right: 30px;
		top: 30px;
		cursor: pointer;
	}

	.btn-page-change {
		width: 52 * @uw;
		height: 124 * @uh;
		position: absolute;
		cursor: pointer;
		font-size: 20 * @uw;
		color: #fff;
		background: rgb(171,119,72);
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
	}

	.btn-start {
		left: 252 * @uw;
		top: 300 * @uh;
	}

	.btn-end {
		left: 252 * @uw;
		top: 450 * @uh;
	}

	.btn-prev {
		right: 252 * @uw;
		bottom: 350 * @uh;
	}
	.btn-next {
		right: 252 * @uw;
		bottom: 200 * @uh;
	}

	.arrow-left {
		position: absolute;
		left: 40px;
		top: calc(45vh);
		cursor: pointer;
	}
	.arrow-right {
		position: absolute;
		right: 40px;
		top: calc(45vh);
		cursor: pointer;
	}

	.viewerContent {
		width: 100%;
		height: 92%;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 100;

		.viewer {
			width: 28%;
			display: inline-block;
			height: 90%;
			// background: violet;
			overflow: auto;

			.frame {
				width: 100%;
				height: 100%;
			}
		}
		.viewer1{
			margin-right: 200px;
		}
	}

	.ctrlBtns {
		width: 30%;
		height: 5%;
		margin-left: 35%;
		border-radius: 5px;
		background: rgba(231, 231, 225, 0.5);
		margin-bottom: 20px;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;

		.ctrl-btn {
			font-size: 30px;
		}
		.page-input {
			width: 70px;
			margin-left: 20px;
			margin-right: 20px;
		}
	}
}
</style>
